/* eslint-disable no-param-reassign */
import axios from 'axios';
import weui from 'weui.js';

import auth from '@/auth';
import router from '@/router';
import conf from '@/config';
import wechat from '@/wechat';
import { ROUTE_TRAINER_APPLY_SEARCH } from '@/router/names';

const requests = axios.create({
    baseURL: conf.api,
    headers: {
        Accept: 'application/json',
    },
});

requests.interceptors.request.use(
    (config) => {
        const token = auth.token();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error),
);

requests.interceptors.response.use(
    resp => resp,
    (error) => {
        const { status, data } = error.response;
        if (status === 401) {
            wechat.authorize(router.currentRoute.fullPath);
        } else if (status === 403) {
            router.replace({
                name: ROUTE_TRAINER_APPLY_SEARCH,
            });
        } else if (status === 422) {
            weui.topTips(data.message);
            Object.entries(data.errors).forEach(([, errs]) => {
                errs.forEach(m => weui.topTips(m));
            });
        } else if (data.message) {
            weui.topTips(data.message);
        }
    },
);

export default requests;



// WEBPACK FOOTER //
// ./src/api/requests.js